import axiosInstance from "./axios.instance";
import axios from "axios";

export const API_GET_URL = async (data) => {
    console.log(data);
    try {
      const resp = await axiosInstance.post(`/asset`, data);
      return resp;
    } catch (err) {
      throw err;
    }
  };
  
